import * as React from "react";
import AddIcon from "@material-ui/icons/Add";
import {withStyles, WithStyles} from "@material-ui/core/styles";
import TranslateNew from "@translate/TranslateNew";
import CloseIcon from "@material-ui/icons/Close";
import {EcoFloatingButtonStyle as styles} from './EcoFloatingButton.style';


const tn = TranslateNew.getInstance();



interface IProps extends WithStyles<typeof styles>
{
  style?:React.CSSProperties;
  specialStyle?:"ANALYZE"|"READY"|"FAIL"
  hide: boolean;
  options: Array<{label:JSX.Element, action:() => void}>;
  isAi?:boolean;
  updateLocalFile?: (event: any) => void;
}

interface IState
{
  fabClicked: boolean;
}

class EcoLayoverButton extends React.Component<IProps, IState> {

  private fileRef: React.RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>();

  constructor(props: IProps)
  {
    super(props);

    this.state = {
      fabClicked: false,
    };
  }

  public render()
  {
    const { classes, hide, style, isAi,updateLocalFile, specialStyle} = this.props;

    let content:JSX.Element = <div/>;
    let fabClasses:string = classes.fab + (this.state.fabClicked?(" "+classes.expanded):"")+ (isAi?(" "+classes.purple):"");

    if (isAi && updateLocalFile) {
      content = <label htmlFor="add-file-direct" 
        onClick={() => {if (this.fileRef.current) {this.fileRef.current.focus();}}}>
        <input type="file" ref={this.fileRef} multiple={false} style = {{opacity:0, position: 'absolute', width:'80%'}} id={"add-file-direct"} 
          onChange={updateLocalFile} accept="capture=camera,image/*" />
        <span>Ai</span>
      </label>
    } else if (this.state.fabClicked && this.props.options.length > 1) {
      content = <>
        {<div key={"close"} className={classes.FABlabel} onClick={() => this.setState({fabClicked:false})}>
            <CloseIcon /><div >{tn.lang.close}</div>
        </div>}
        {this.props.options.map((option, index) => 
          <div key={index} className={classes.FABlabel} 
            onClick={() => {option.action();}}>
            {option.label}
        </div>)}</>;
    } else if (specialStyle !== undefined && this.props.options.length === 1) {
      if (specialStyle === "ANALYZE") {
        fabClasses = fabClasses + " " + classes.grey;
      }
      content = 
        <div onClick={this.props.options[0].action}>
            {this.props.options[0].label}
        </div>
    } else {
      content = <AddIcon  style={{fontSize:"42px"}} />;
    }


    let fabBgClasses:string|undefined ;
    if (specialStyle === "ANALYZE") {fabBgClasses=classes.aiAnalyzingBackground;}
    if (specialStyle === "READY") {fabBgClasses=classes.aiReadyBackground;}
    if (specialStyle === "FAIL") {fabBgClasses=classes.aiFailedBackground;}

    return (
      <div className={classes.container} style={style}>
        <div className={fabBgClasses}/>
        <div
            style={{position: 'absolute',right:0,bottom: 0, pointerEvents:(hide?"none":"auto"), scale:(hide?"0":specialStyle?"0.8":"1")}}
            className={fabClasses}
            onClick={() => {if(this.props.options.length === 1) {
                  this.props.options[0].action();
                } else if (this.props.options.length > 1) {
                  this.setState({fabClicked:!this.state.fabClicked})
                }
              }}
        >
          {content}
        </div>
      </div>
    );
  }

}

export default withStyles(styles)(EcoLayoverButton);



// WEBPACK FOOTER //
// ./src/components/economy/EcoFloatingButton.tsx